import createPersistedState from 'vuex-persistedstate';
import axios from 'axios';
import Vue from 'vue'
import Vuex from 'vuex'
import { rejoin, split } from './token-hash';
import SecureLS from "secure-ls";
import Cookie from 'js-cookie';
const ls = new SecureLS({ encodingType: 'aes' });

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    TYST: null,
    TYSP: null,
    TYSD: null,
    TYUT: [0,0,0], //user, developer, admin
    isAdmin: false,
    isUser: false,
    theme: 'light',
    loading: false,
    isDeveloper: false,
    personal_instance: null,
    up_p: false,
    payment_redirect_url: null,
    payment_redirect_url_date: null,
  },
  mutations: {
    setUserToken (state, token) {
      [state.TYST, state.TYSP, state.TYSD] = split(token, 3);
      Cookie.set('tkn', token, {secure: true})
      
    },
    removeUserToken (state) {
      state.TYST = null;
      state.TYSP = null;
      state.TYSD = null;
      state.TYUT[0] = 0;
      state.TYUT[1] = 0;
      state.TYUT[2] = 0;
    },
    changeTheme (state) {
      if (state.theme=='light') state.theme = 'dark';
      else state.theme = 'light';
    },
    resetState (state) {
      state.TYST = null;
      state.TYSP = null;
      state.TYSD = null;
      state.TYUT[0] = 0;
      state.TYUT[1] = 0;
      state.TYUT[2] = 0;
    },
    setLoading(state, bool) {
      state.loading = bool;
    },
    setPersonalInstance(state, id) {
      state.personal_instance = id;
    },
    setRoles (state, {role, is_developer}) {
      state.TYUT[2] = role=='admin'?1:0;
      state.TYUT[0] = role=='user'?1:0;
      state.TYUT[1] = is_developer;
    },
    setUpdateInventory (state) {
      state.up_p = !state.up_p;
    },
    setPaymentRedirectUrl (state, next) {
      state.payment_redirect_url = next;
      state.payment_redirect_url_date = new Date();
    }
  },
  getters: {
    
    username: async (state, getters) => {
      if (!getters.USER_TOKEN) return 'ورود';
      let tmp = 'حساب کاربری';
      const user = await getters.USER;
      if (user.name) tmp = user.name;
      else tmp = user.mobile;
      return tmp;
    },

    isAdmin: (state, getters) => {
      return (getters.USER_TOKEN !== null && state.TYUT[2]);
    },
    isUser: (state, getters) => {
      return (getters.USER_TOKEN !== null && state.TYUT[0]);
    },
    isDeveloper: (state, getters) => {
      return (getters.USER_TOKEN !== null && state.TYUT[1]);
    },

    userType: async (state, getters) => {
      if (getters.USER_TOKEN !== null) {
        return state.TYUT[2]?'admin':state.TYUT[1]?'developer':state.TYUT[0]?'user':null
        // const user = await getters.USER;
        // if (!user) return null;
        // if (user.is_developer) {
        //   return 'developer'
        // }
        // if (user.role == 'user') {
        //   return 'user'
        // }
        // if (user.role == 'admin') {
        //   return 'admin'
        // } else {
        //   return null
        // }
      }
      return null;
    },

    USER_TOKEN: (state) => {
      return rejoin([state.TYST, state.TYSP, state.TYSD]);
    },
    USER: async ( state, getters ) => {
      if (!getters.USER_TOKEN) return null;
      try {
        const res = await axios
        .get(
          `${process.env.VUE_APP_baseURL}/user/me`,
            {
              headers: {
                Authorization: `Bearer ${getters.USER_TOKEN}`
              }
            }
        );
        // if (!res.data.id) {
        //   this.commit('removeUserToken')
        // }
        return res.data;
      } catch {
        // this.commit('removeUserToken')
        return null;  
      }
    },
    theme: state => {
      return state.theme;
    },
    getLoading: state => {
      return state.loading;
    },
    personal_instance: state => {
      return state.personal_instance;
    },
    update_inventory: state => {
      return state.up_p;
    },
    payment_redirect_url: state => {
      if (!state.payment_redirect_url_date) return null;
      const diff = Math.abs(Math.floor((new Date().getTime() - new Date(state.payment_redirect_url_date).getTime()) / (1000*60*60)))
      return diff<1&&state.payment_redirect_url?'//'+state.payment_redirect_url:null;
    }
  },
  actions: {
    async auth (context) {
      if (!context.getters.USER_TOKEN) return false;
      try {
        const res = await axios
        .get(
          `${process.env.VUE_APP_baseURL}/user/me`,
            {
              headers: {
                Authorization: `Bearer ${context.getters.USER_TOKEN}`
              }
            }
        );
        if (!res.data.id) {
          context.commit('removeUserToken')
          return false;
        } else {
          Cookie.set('tkn', context.getters.USER_TOKEN, {secure: true})
          context.state.TYUT[0] = res.data.role == 'user'?1:0;
          context.state.TYUT[2] = res.data.role == 'admin'?1:0;
          context.state.TYUT[1] = res.data.is_developer;
          return true; 
        }
      } catch {
        context.commit('removeUserToken')
        return false;  
      }
    },
    exit({commit}) {
      commit('resetState')
      
    }
  },
  plugins: [createPersistedState({
    storage: {
      getItem: (key) => {
        try {
          return ls.get(key)
        } catch {
          ls.remove(key);
          return null
        }
      },
      setItem: (key, value) => ls.set(key, value),
      removeItem: key => ls.remove(key)
    },
    key: '_state',
  })],
})
